import { render, staticRenderFns } from "./data29.vue?vue&type=template&id=9176439a&scoped=true&"
import script from "./data29.vue?vue&type=script&lang=js&"
export * from "./data29.vue?vue&type=script&lang=js&"
import style1 from "./data29.vue?vue&type=style&index=1&id=9176439a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9176439a",
  null
  
)

export default component.exports